import type { SortingState } from '@tanstack/react-table';
import { atom } from 'jotai';

import type { FilterState } from '@/features/dashboard/components/filter-bar';

/**
 * Dashboard view state (filters, pagination, sorting) persisted across route
 * navigation so users don't lose their applied filters when they open a report
 * and return to the dashboard.
 */
export interface DashboardViewState {
  filters: FilterState;
  page: number;
  pageSize: number;
  sorting: SortingState;
}

export const DEFAULT_DASHBOARD_VIEW_STATE: DashboardViewState = {
  filters: {
    search: '',
    dateFilter: { preset: 'this_month' },
    riskLevels: [],
    reportWindow: [],
  },
  page: 1,
  pageSize: 20,
  sorting: [{ id: 'dateReportGenerated', desc: true }],
};

export const dashboardViewStateAtom = atom<DashboardViewState>(DEFAULT_DASHBOARD_VIEW_STATE);
